import 'dateformat'

export default {
  init(selector, config) {

  },
  finalize() {

    const current_end_date = $('.end_date').text();

    $('#extensionTimeSelect').on('change', function() {

      const time_period = this.value;
      let displayEndDate = current_end_date;
      if (time_period){
        const dateFormat = require('dateformat');
        const newEndDate = new Date(current_end_date);
        newEndDate.setDate(newEndDate.getDate() + 7 * time_period); // Add  days
        displayEndDate = dateFormat(newEndDate, "ddd dd mmm yyyy");
      }
      $( "span.end_date" ).html( displayEndDate );
      $("#newCompletionTime").hide();
      $( "span.new_date_display" ).html( displayEndDate );
      $("#newCompletionTime").show('slow');

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/online-course-extension.js